import styled, { css } from 'styled-components';
import LinkHandler from '../link-handler';
import { linkOnDarkBgStyles } from '../styled/links';
import { breakpoint } from '../theme/breakpoint';
import RichText from '../rich-text/base';

export const Wrapper = styled.div`
  ${({ $hasDataLoaded, $backgroundColor, theme }) => css`
    overflow: hidden;
    padding: ${theme.spacing.xlarge} ${theme.spacing.standard};
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    text-align: center;
    background-color: ${($backgroundColor === 'White' && theme.palette.white) ||
    ($backgroundColor === 'Black' && theme.palette.darkBackground)};
    color: ${($backgroundColor === 'White' && theme.palette.standardText) ||
    ($backgroundColor === 'Black' && theme.palette.white)};

    ${!$hasDataLoaded
      ? `
      height: 350px;
      justify-content: center;
    `
      : null}

    height: ${$hasDataLoaded ? 'auto' : '350px'};

    ${breakpoint.mobile`
      height: ${$hasDataLoaded ? 'auto' : '316px'};
    `}

    ${breakpoint.mobileLand`
      height: ${$hasDataLoaded ? 'auto' : '350px'};
    `}
  `}
`;

export const Heading = styled.h2`
  margin-top: 0;
`;

export const SubText = styled(RichText)`
  max-width: 635px;
`;

export const Timer = styled.div`
  ${({ $backgroundColor, $isTimerHighlighted, theme }) => css`
    background-color: ${($backgroundColor === 'White' && theme.palette.white) ||
    ($backgroundColor === 'Black' && theme.palette.darkBackground)};
    color: ${($backgroundColor === 'White' && theme.palette.standardText) ||
    ($backgroundColor === 'Black' && theme.palette.white)};
    font-size: ${$isTimerHighlighted
      ? theme.fontsize.mobile.h2
      : theme.fontsize.mobile.h3};
    padding: ${theme.spacing.tiny};
    font-weight: bold;
    display: grid;
    grid-template-columns:
      minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr)
      auto minmax(0, 1fr);
    gap: 4px;

    ${breakpoint.mobile`
      font-size: ${
        $isTimerHighlighted
          ? theme.fontsize.mobile.h2
          : theme.fontsize.mobile.h3
      };
    `}

    ${breakpoint.mobileLand`
      font-size: ${$isTimerHighlighted ? theme.fontsize.h2 : theme.fontsize.h3};
    `}

    ${breakpoint.tablet`
      gap: ${theme.spacing.standard};
      grid-template-columns: 70px auto 70px auto 70px auto 70px;
    `}
  `}
`;

export const TimeUnit = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-weight: ${theme.fontWeight.normal};
    font-size: ${theme.fontsize.standard};
    font-variant-numeric: tabular-nums;
    text-wrap: nowrap;
  `}
`;

export const TimeAmount = styled.span`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-weight: ${theme.fontWeight.bold};
  `}
`;

export const CTAWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.medium};
  `}
`;

export const LinkCTA = styled(LinkHandler)`
  ${({ $backgroundColor }) => css`
    ${$backgroundColor === 'Black' ? linkOnDarkBgStyles : null};
  `}
`;

export const HiddenMobile = styled.span`
  display: none;

  ${breakpoint.mobile`
      display: inline;
  `}
`;
